<template>
  <validation-observer v-slot="{ handleSubmit, valid }">
    <form @submit.prevent="handleSubmit(onSubmit)">
      <v-row>
        <v-col>
          <validation-provider v-slot="{ errors }" rules="required" name="title">
            <v-text-field label="Title" name="title" flat outlined :hide-details="false" :error="errors.length > 0"
              :error-count="errors.length" :error-messages="errors" v-model="formModel.group_name" />
          </validation-provider>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex justify-end">
          <v-btn plain class="mr-2" @click="onCancel" :disabled="loading">
            Cancel
          </v-btn>
          <v-btn type="submit" color="primary" :disabled="!valid || loading" :loading="performingPodiumAction">
            Authorize Podium
          </v-btn>
        </v-col>
      </v-row>
    </form>
  </validation-observer>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { usePodiumAuth } from './usePodiumAuth';

const { mapActions: workflowsActions, mapGetters: workflowsGetters } =
  createNamespacedHelpers('workflows/list');
const { mapActions: credsActions } = createNamespacedHelpers('credentials');

export default {
  name: 'PodiumForm',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    credentialToEdit: {
      type: Object,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      code: null,
      formModel: {
        group_name: '',
      },
    };
  },
  computed: {
    ...workflowsGetters({
      performingPodiumAction: 'PERFORM_PODIUM_ACTION',
    }),
  },
  methods: {
    ...workflowsActions(['podiumAction']),
    ...credsActions(['fetchAuthentications']),
    async authorizePodium() {
      try {
        const { getAuthCode } = usePodiumAuth();
        const authCode = await getAuthCode();
        this.code = authCode;
        await this.submitWithCode();
      } catch (error) {
        this.$store.dispatch(
          'notifications/setError',
          'Failed to authenticate with Podium',
          { root: true },
        );
        // Reopen modal to allow retry
        this.$emit('reopen');
      }
    },
    async submitWithCode() {
      if (!this.code && this.isEdit) {
        this.$emit('submit-form', this.formModel);
      } else if (this.code) {
        const data = {
          group_name: this.formModel.group_name,
          code: this.code,
          action: 'get_token',
        };
        if (this.isEdit) {
          data['authenticationId'] = this.credentialToEdit?.id;
        }

        try {
          const response = await this.podiumAction(data);
          if (response && response.success) {
            this.$store.dispatch(
              'notifications/pushNotification',
              'Successfully logged in to Podium',
              { root: true },
            );
            await this.fetchAuthentications();
            this.onCancel();
          } else {
            throw new Error('Failed to authenticate with Podium');
          }
        } catch (error) {
          this.$store.dispatch(
            'notifications/setError',
            error.message || 'Failed to authenticate with Podium',
            { root: true },
          );
          this.$emit('reopen');
        }
      }
    },
    async onSubmit() {
      await this.authorizePodium();
    },
    onCancel() {
      this.$emit('close');
    },
  },
  mounted() {
    if (this.isEdit) {
      const { name, credentials } = this.credentialToEdit;
      this.formModel = {
        group_name: name,
        credentials_list: credentials.map((item) => ({
          ...item,
          is_disabled: item.is_encrypted,
        })),
      };
    }
  },
};
</script>
